import {serializable, alias, object, list, primitive} from 'serializr';

export class Subscription { 

	@serializable(alias('id', primitive()))
	id?: number;

	@serializable(alias('productName', primitive()))
	name?: string;

	@serializable(alias('boardName', primitive()))
	boardName?: string;

	@serializable(alias('isTrial', primitive()))
	isTrial?: boolean;

	@serializable(alias('startDate', primitive()))
	startDate?: string;

	@serializable(alias('endDate', primitive()))
	endDate?: string;
}
